import { HotelPurchaseModel } from 'api-hooks/order/hotel';
import { ChevronDown } from 'baseui/icon';
import { CloseSVG } from 'common/assets';
import { string2money } from 'common/utils/string';
import { Input } from 'components/elements';
import { Button, IconButton } from 'components/elements/buttons';
import Form, { useFormState } from 'components/elements/form';
import Text from 'components/elements/text';
import useDrawer from 'hooks/use-drawer';
import { ButtonContainer, SeparatorHorizontal } from 'legacy-modules/styles';
import useTranslation from 'next-translate/useTranslation';
import * as React from 'react';
import { useFormContext } from 'react-hook-form';

import SummaryDrawer from './summary-drawer';
import useRecalculate from '../../hooks/use-recalculate';
import {
  SummaryContent,
  SummaryLeftContainer,
  SummaryRightContainer,
} from '../../style';
import { HotelPurchaseFormType } from '../form-type';

interface Props {
  hotelPurchase?: HotelPurchaseModel;
}

export default function SummaryHotelPurchase(props: Props) {
  const { t } = useTranslation();
  const methods = useFormContext<HotelPurchaseFormType>();

  const {
    formState: { isSubmitting },
    clearErrors,
    reset,
  } = methods;

  const drawer = useDrawer();

  const onOpenSummaries = React.useCallback(() => {
    drawer.showCustom({
      backdropClose: true,
      render: (close) => (
        <Form methods={methods} onSubmit={() => {}}>
          <SummaryDrawer onClose={close} />
        </Form>
      ),
    });
  }, [drawer, methods]);

  const { total } = useRecalculate();
  const { editable, setIsEditable } = useFormState();

  return (
    <SummaryContent>
      <SummaryLeftContainer>
        <Text variant={{ initial: 'LabelSmall', md: 'LabelLarge' }}>
          {t('common:total_order')}:
        </Text>
        <SeparatorHorizontal $margin={16} />
        <Text
          variant={{ initial: 'HeadingXSmall', md: 'HeadingSmall' }}
        >{`Rp. ${string2money(total)}`}</Text>
        <SeparatorHorizontal $margin={16} />
        <IconButton buttonType="tertiary" onClick={onOpenSummaries}>
          <ChevronDown size={24} />
        </IconButton>
      </SummaryLeftContainer>
      <SummaryRightContainer>
        {editable && props.hotelPurchase && !isSubmitting && (
          <>
            <ButtonContainer style={{ marginLeft: 16 }}>
              <Button
                buttonType="secondary"
                startEnhancer={(color, size) => (
                  <CloseSVG width={size} height={size} color={color} />
                )}
                onClick={() => {
                  setIsEditable(false);
                  clearErrors();
                  reset();
                }}
              >
                {t('common:cancel')}
              </Button>
            </ButtonContainer>
            <SeparatorHorizontal $margin={24} />
          </>
        )}
        <Input
          type="submit"
          overrides={{
            Root: {
              style: {
                flex: 1,
              },
            },
          }}
        />
      </SummaryRightContainer>
    </SummaryContent>
  );
}
